import Model from 'core/model/Model';

class RecentView extends Model {
  get urlRoot() {
    return '/api/ui/recent-view';
  }
}

export default RecentView;
